var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-panel-group"},[_c('h3',[(_vm.header.url)?_c('a',{attrs:{"href":_vm.header.url,"target":_vm.header.target}},[_vm._v(_vm._s(_vm.header.name))]):_c('span',[_vm._v(_vm._s(_vm.header.name))])]),_c('LinkList',{attrs:{"links":_vm.links,"unstyle":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }